import { usePipelinePreload } from '../providers/PipelinePreloadProvider';

/**
 * This hook returns the pipeline from context if provided, otherwise null
 * @returns {Pipeline | null}
 */
export const usePipeline = () => {
  let pipeline = null;
  try {
    const pipelinePreload = usePipelinePreload();
    pipeline = pipelinePreload.pipeline;
    return pipeline;
  } catch (e) {
    return pipeline;
  }
};